export default "__VITE_ASSET__tEy0XDbB__"